import axios from "axios";
import { authorizeTheCallToApi } from "../API/authorization";
import { GET_RESERVATION_HISTORY_API } from "../../models/services/lounge.services";

export type ReservationHistoryType =
  | "creacion"
  | "estado"
  | "empleado"
  | "fechahora"
  | "servicio"
  | "cliente"
  | "precio"
  | "notas"
  | "cancelacion"
  | "en_comanda"
  | "auto_por_asignar";

export interface IReservationHistoryItem {
  id: number;
  type: ReservationHistoryType | string;
  description: string;
  oldValue: string | null;
  newValue: string | null;
  reservationDetailId: number | null;
  authorName: string | null;
  isSystem: boolean;
  date: string;
}

export const apiGetReservationHistory = async (
  id: number | string
): Promise<{
  status: number;
  data: IReservationHistoryItem[];
  message: string;
}> => {
  try {
    const AUTHORIZATION = { ...authorizeTheCallToApi() };
    const CONFIG = {
      ...AUTHORIZATION,
    };

    const response = await axios.get(GET_RESERVATION_HISTORY_API(id), CONFIG);

    return {
      status: 200,
      data: response.data.data,
      message: response.data.message || "Historial obtenido exitosamente",
    };
  } catch (error) {
    return {
      status: 500,
      data: [],
      message:
        error?.response?.data?.message || "Error al obtener el historial",
    };
  }
};
